import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import HeatToElectricalEnergyDetail from '../../components/renewable_energy/HeatToElectricalEnergyDetail';
import { editHeatToElectricalEnergy } from '../../redux/renewable_energy/heat_to_electrical_energy_actions';
import { defaultRejectHandler } from '../../utils/utility';

class HeatToElectricalEnergyEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.renewableEnergyDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newRenewableEnergy = this.renewableEnergyDetail.getWrappedInstance().getRenewableEnergyData();
    this.props.editHeatToElectricalEnergy({ ...newRenewableEnergy, id: this.props.renewableEnergy.id });
  }

  render() {
    const { isEditing, errorMessage, renewableEnergy, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit heat to electrical energy')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HeatToElectricalEnergyDetail
            renewableEnergy={renewableEnergy}
            ref={ref => (this.renewableEnergyDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="heat-to-electrical-energy-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const heatToElectricalEnergyState = state.renewableEnergy.heatToElectricalEnergy;
  return {
    errorMessage: heatToElectricalEnergyState.errorMessage,
    isEditing: heatToElectricalEnergyState.isEditing,
  };
};

const mapDispatchToProps = dispatch => ({
  editHeatToElectricalEnergy: renewableEnergy =>
    defaultRejectHandler(
      dispatch(
        editHeatToElectricalEnergy(
          renewableEnergy.id,
          renewableEnergy.name,
          renewableEnergy.entropy,
          renewableEnergy.volume,
          renewableEnergy.description,
          renewableEnergy.image,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(HeatToElectricalEnergyEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/renewable_energy/HeatToElectricalEnergyEditModal.js